import { render, staticRenderFns } from "./ViewTagPage.vue?vue&type=template&id=5222d4ae&"
import script from "./ViewTagPage.vue?vue&type=script&lang=js&"
export * from "./ViewTagPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports